import { Nullable } from "@/types";

export class DataUtil {
  /**
   * Formats the specified lineNumber with left padded zeros
   *
   * @example 1 => 001
   * @param {number} lineNumber
   */
  public static formatLineNumber(lineNumber: number) {
    const str = "" + lineNumber;
    const pad = "000";
    return pad.substring(0, pad.length - str.length) + str;
  }

  public static computeRowSpan(item: ISalesOrderNumber, index: number, list: ISalesOrderNumber[]) {
    return index === 0 || item.SalesOrderNumber !== list[index - 1].SalesOrderNumber
      ? list.filter((x) => x.SalesOrderNumber === item.SalesOrderNumber).length
      : null;
  }

  public static newGuid(): string {
    const u = Date.now().toString(16) + Math.random().toString(16) + "0".repeat(16);
    return [u.substr(0, 8), u.substr(8, 4), "4000-8" + u.substr(13, 3), u.substr(16, 12)].join("-");
  }

  public static isLikelyToBeLocalizedString(value?: Nullable<string>): boolean {
    return value && value.endsWith("Long") && value.indexOf(" ") === -1 ? true : false;
  }

  public static formatNumber(num: number): string {
    if(!num){
      return "";
    }
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }
}

export interface ISalesOrderNumber {
  SalesOrderNumber: string;
}
